import axios from 'axios';
import { isFromAppMobileWaitSession } from 'Utils/mobile';
import { purchaseRedirect } from 'Utils/purchaseRedirect';

export const isUnauthenticatedError = (error) => {
  const { response } = error;
  return response?.status === 401;
};

const fetch = async (url, config) => {
  const isMobileAppWaitSession = isFromAppMobileWaitSession();

  try {
    return await axios(url, config);
  } catch (error) {
    if (isUnauthenticatedError(error)) {
      if (!isMobileAppWaitSession) purchaseRedirect();
    }
    throw error;
  }
};

export default fetch;
